
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Sobre Nosotros
            </h2>
            <div className="space-y-5 text-slate-600 text-base leading-relaxed">
              <p>
                <strong className="text-slate-900">BIGBATTERY EUROPE SL (BBE)</strong> es un fabricante europeo especializado en soluciones de integración de infraestructura crítica para centros de datos de alta confiabilidad y sistemas avanzados de almacenamiento de energía.
              </p>
              <p>
                Contamos con <strong className="text-slate-900">producción independiente de equipos clave</strong> y tecnología central propia.
              </p>
              <p>
                Somos fabricante con <strong className="text-slate-900">certificación CE</strong> y operamos bajo estrictos sistemas <strong className="text-slate-900">ISO de calidad y medio ambiente</strong>, garantizando productos seguros, eficientes y de alto rendimiento.
              </p>
              <p>
                Sede operativa en <strong className="text-slate-900">Barcelona, España</strong>, con red comercial global.
              </p>
            </div>
            
            <div className="grid grid-cols-2 gap-6 mt-12">
              <div className="bg-slate-50 p-6 rounded-lg">
                <div className="text-blue-900 text-3xl font-bold mb-2">CE</div>
                <div className="text-slate-700 text-sm font-medium">Certificación Europea</div>
              </div>
              <div className="bg-slate-50 p-6 rounded-lg">
                <div className="text-blue-900 text-3xl font-bold mb-2">ISO</div>
                <div className="text-slate-700 text-sm font-medium">Calidad y Medio Ambiente</div>
              </div>
              <div className="bg-slate-50 p-6 rounded-lg">
                <div className="text-blue-900 text-3xl font-bold mb-2">100%</div>
                <div className="text-slate-700 text-sm font-medium">Fabricación Propia</div>
              </div>
              <div className="bg-slate-50 p-6 rounded-lg">
                <div className="text-blue-900 text-3xl font-bold mb-2">EU</div>
                <div className="text-slate-700 text-sm font-medium">Ingeniería Europea</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/e235e03827621791923965ed6c087dc0.jpg"
                alt="Instalaciones de Fabricación"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-blue-900 text-white p-8 rounded-xl shadow-xl max-w-xs">
              <div className="text-sm font-medium mb-2">Sede Operativa</div>
              <div className="text-2xl font-bold">Barcelona, España</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
